import { Box, Card, Container, Flex, Text } from "@radix-ui/themes"
import React from "react"
import { IUser } from "../../../core/types/services-types/user-types"
import Avatar from "./avatar-render"

export interface UserCardRenderProps {
    user: IUser,
    onClick: (user: IUser) => any,
    actions?: (user: IUser) => React.JSX.Element
}


export default function UserCardRender(props: UserCardRenderProps) {
    const {user, onClick, actions} = props
    return (
        <Box className="hover:shadow-xl transition-shadow cursor-pointer rounded-none" onClick={() => onClick(user)}>
        <Card className="border-none" style={{border: 'none'}}>
            <Flex gap="3" align="center">
                  <Avatar name={user.login} />
                <Box>
                    <Text as="div" size="2" weight="bold">
                        {user.login}
                    </Text>
                    <Text as="div" size="2" color="gray">
                        {user.role === 'admin' ? "Администратор" : "Пользователь"}
                    </Text>
                </Box>
                 <Box>
                    {actions ? actions(user) : ''}
                 </Box>
            </Flex>
        </Card>
    </Box>
    )
}